export class LookUpModel {
    id: number;
    name: string;
    value: any;
    followUpDays: any;
    followUpDaysLimit: any;
    visitTypeId: number;
    visitorName: string;
}